/* Fuerza que los chunks dinámicos se pidan desde la raíz */
// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = '/';

// Redirect sistema-bks.web.app → app.pux.app (canonical domain)
if (window.location.hostname === 'sistema-bks.web.app') {
  window.location.replace('https://app.pux.app' + window.location.pathname + window.location.search + window.location.hash);
}